<div class="menu" *ngIf="Heading">
    <span class="menu-heading">{{ Heading }}</span>
    <span class="close" (click)="closeCaseCreation()">X</span>
  </div>
  <div class="container">
    <div *ngIf = "showSearch == true">
        <app-search-dialog (selectedSearchedItem)="handleSelectedUser($event)"  [isSearchTriggered]="false" [hideNotFoundButton]="false" (notFoundAddNew)="handleSelectedUser($event)" [searchObject]="searchMemberObject" [isUserSelection]="addNewUser" ></app-search-dialog>

    </div>
    <div class="row container-fluid member-info-search" *ngIf = "showAddUser == true" style="padding-top:0.3rem;" >
        <div class="row memberinfo">Add a New User</div>
        <div class="search-field-container">
            <form #userForm="ngForm" (ngSubmit)="confirm(userForm)">
          <!-- <form> -->
            <div class="row">
                <div class="col-4">
                    <label class="search-field-label">First Name</label>
                    <input type="text" name="firstName" class="search-field" [(ngModel)]="addMemberData.FirstName" #firstName="ngModel" required > 
                    <div *ngIf="firstName.invalid && (submitted || firstName.touched)">
                    <small *ngIf="firstName.errors?.['required']" class="star">First Name is required.</small> 
                    </div>
                    <!-- <label class="search-field-label">First Name</label>
                    <span class="star"> *</span> 
                    <input type="text" name="carrier" class="search-field"  [(ngModel)]="addMemberData.FirstName" > -->
                </div>
                <div class="col-4">
                    <label class="search-field-label">Last Name</label>
                    <input type="text"  name="lastName" class="search-field"  [(ngModel)]="addMemberData.LastName" #lastName="ngModel" required>
                    <div *ngIf="lastName.invalid && (submitted || lastName.touched)">
                    <small *ngIf="lastName.errors?.['required']" class="star">Last Name is required.</small> </div>
                    <!-- <label class="search-field-label">Last Name</label>
                    <span class="star"> *</span> <br />
                    <input type="text" name="name" class="search-field"  [(ngModel)]="addMemberData.LastName"/> -->
                </div>
                <div class="col"></div>
            </div>
            <div class="row">
                <div class="col-4">
                    <label class="search-field-label">Email Address</label>
                    <input 
                 type="email" name="email" class="search-field"  [(ngModel)]="addMemberData.Email" #email="ngModel" required email>
                 <div *ngIf="email.invalid && (submitted || email.touched)">
             <small *ngIf="email.errors?.['required']" class="star">Email is required.</small>
             <small *ngIf="email.errors?.['email']" class="star" >Please enter a valid email address.</small>
            </div>

                    <!-- <label class="search-field-label">Email Address</label>
                    <span class="star"> *</span> <br />
                    <input type="email" name="email" class="search-field"  [(ngModel)]="addMemberData.Email"> -->
                </div>
                <div class="col-4">
                    <label class="search-field-label">Telephone</label>
                    <input type="text" name="name" class="search-field"  [(ngModel)]="addMemberData.Phone"/>
                    
                </div>
                <div class="col"></div>
            </div>
            <div class="btn-wrapper mt-3 mb-3">
                <!-- <span *ngIf="isConfirm === true"> -->
                <input  class="outline-btn ms-2" type="button" value="Cancel" (click)="cancel()" />

                <input
             class="main-btn ms-2"
             type="submit"
             value="Ok"
              />

                <!-- <input
                  class="main-btn ms-2"
                  type="submit"
                  value="Ok"
                  (click)="confirm()"
                /> -->
                <!-- <input class="btn btn-default confirm-btn" type="submit" [value]="confirmBtnValue" (click)="confirm()" /> -->
                <!-- </span> -->
                <!-- <span *ngIf="isDelete === true"> -->
                <!-- </span> -->
                <!-- <input class="btn btn-default cancel-btn" type="submit" [value]="cancelBtnValue" (click)="cancel()" /> -->
              </div>
          </form>
        </div>
    </div>
   
  </div>

